import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../hooks'
import { getQaSelector } from '../../../../../utils/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { updateNewsboard } from '../../../Newsboard.api'

import { QA_NAME_PIN_ACTION_BUTTON } from './NewsboardPostHeaderPinAction.constants'
import { getActionPermission } from './NewsboardPostHeaderPinAction.utils'

import PinIcon from '../../../../../icons/pin.svg'
import PinnedIcon from '../../../../../icons/pin-filled.svg'

function NewsboardPostHeaderPinAction({
  data: { is_pinned: pinned, permissions, uuid },
  onReload,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const Icon = pinned ? PinnedIcon : PinIcon

  const permissionForAction = getActionPermission(pinned, permissions)

  function handleClick() {
    if (permissionForAction) {
      updateNewsboard(uuid, { pinned: !pinned })
        .then(() => {
          onReload()
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
    }
  }

  const qaProps = getQaSelector({ value: QA_NAME_PIN_ACTION_BUTTON })

  return permissionForAction || pinned ? (
    <Button.Flat
      beforeIconProps={{ Icon }}
      dataProps={qaProps}
      height={BUTTON_HEIGHT_32}
      interactive={permissionForAction}
      isGrey={!pinned}
      tooltip={
        permissionForAction
          ? t(
              pinned
                ? 'Newsboard.UnpinPostTooltipKey'
                : 'Newsboard.PinPostTooltipKey'
            )
          : undefined
      }
      onClick={handleClick}
    />
  ) : null
}

export default NewsboardPostHeaderPinAction
